import React, { useContext } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connectHierarchicalMenu } from 'react-instantsearch-dom';
import { useParams } from 'react-router-dom';

import { DiscoverContext } from '../../../../context/DiscoverContext';
import { DEFAULT_URL } from '../../const';
import { CategoryNavigation } from '../CategoryNavigation';
import useStyles from './styles';

export const CategoryNavigationBlock = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const params = useParams();
  const { categoryTitle } = useContext(DiscoverContext);

  const { category, subcategory } = params;

  return (
    <Box className={classes.wrapper}>
      {subcategory && (
        <CategoryNavigation
          link={`${DEFAULT_URL}/${category}`}
          title={t('page.discover.backTo', { category: categoryTitle })}
        />
      )}
      <CategoryNavigation link={`${DEFAULT_URL}/search`} title={t('page.discover.backToLanding')} />
    </Box>
  );
};

export default connectHierarchicalMenu(CategoryNavigationBlock);
